export default {
    setZoom({commit}, histoWf) {
        commit('CHANGE_ZOOM', histoWf);
      },
};
